import { createLayouts } from '@layouts'
import '@layouts/styles/index.scss'
import { layoutConfig } from '@themeConfig'

//export default createLayouts(layoutConfig)

export default function (app) {
  app.use(createLayouts(layoutConfig))
}
